import type { ParamsHOCChildrenProps } from 'labstep-web/hoc/Params/types';
import type { StateUIPersistentFilters } from 'labstep-web/state/reducers/ui-persistent';

export enum State {
  collapsed = 'collapsed',
  uncollapsed = 'uncollapsed',
}

export type ExperimentWorkflowIndexViewType =
  | 'list'
  | 'timeline'
  | 'grid';

// Union of all possible filter names across all entity filter interfaces
export type FilterName =
  | 'status'
  | 'status_type'
  | 'signatures'
  | 'assignee'
  | 'created_by'
  | 'tag'
  | 'resource_template'
  | 'extension'
  | 'tag_type'
  | 'unstarted'
  | 'started'
  | 'completed';

export interface TypeToggleUiFilterAction {
  type: 'SET_UI_FILTER';
  entityName: keyof StateUIPersistentFilters;
  filter: FilterName;
}
export interface TypeSetUiCountPerPageAction {
  type: 'SET_UI_COUNT_PER_PAGE';
  count: number;
}

export interface TypeResetAction {
  type: 'RESET_UI_PERISTENT';
}

export type TypeResetActionCreator = () => TypeResetAction;

export interface TypeSetUiExperimentWorkflowViewAction {
  type: 'SET_UI_EXPERIMENT_WORKFLOW_VIEW';
  view: ExperimentWorkflowIndexViewType;
}

export interface TypeSetUiSearchParamsAction {
  type: 'SET_UI_SEARCH_PARAMS';
  pathname: string;
  params: ParamsHOCChildrenProps['searchParams'];
}

export type TypeToggleUiFilterActionCreator = (
  entityName: TypeToggleUiFilterAction['entityName'],
  filter: TypeToggleUiFilterAction['filter'],
) => TypeToggleUiFilterAction;

export type TypeSetUiExperimentWorkflowViewActionCreator = (
  view: TypeSetUiExperimentWorkflowViewAction['view'],
) => TypeSetUiExperimentWorkflowViewAction;

export type TypeSetUiSearchParamsActionCreator = (
  pathname: TypeSetUiSearchParamsAction['pathname'],
  params: TypeSetUiSearchParamsAction['params'],
) => TypeSetUiSearchParamsAction;

export type TypeSetUiCountPerPageActionCreator = (
  count: TypeSetUiCountPerPageAction['count'],
) => TypeSetUiCountPerPageAction;
